/*
 *   File : payment-options.js
 *   Author : https://evoqins.com
 *   Description :  Payment options radio group component
 *   Integrations : NA
 *   Version : 1.0.0
*/

import React, { memo } from "react";

// Assets
import UPIAutopay from "../../Assets/Images/Onboarding/upi-autopay.svg";
import BankENach from "../../Assets/Images/Onboarding/ban-enach.svg";
import Active from "../../Assets/Images/circle-active.svg";
import Inactive from "../../Assets/Images/circle-inactive.svg";

const MANDATE_TYPES = [
    { id: 1, image: UPIAutopay, label: "UPI Autopay", description: "Fast,instant approval via UPI apps", slug: "UPI" },
    { id: 2, image: BankENach, label: "Bank eNACH", description: "Approve using your bank login", slug: "E_MANDATE" }
];

function MandateOptions(props) {
    return (
        <>
            {
                props.type == 2 ?
                    <div className='d-flex flex-column gap-3'>
                        {
                            MANDATE_TYPES.map((data, key) => (
                                <React.Fragment key={key}>
                                    <div className={`${props.selectedType !== data.slug ? "cursor-pointer" : "cursor-default"} d-flex align-items-center gap-2 padding-12px-all e-border-radius-16 e-border-1px-crystal-blue`}
                                        onClick={() => props.handleTypeSelect(data.slug)}>
                                        <img src={data.image}
                                            width={32}
                                            height={32}
                                            className='width-24px-res'
                                            alt={`payment method ${data.label}`}
                                            draggable="false" />
                                        <div className="d-flex flex-column flex-fill gap-1">
                                            <p className="e-text-charleston-green mb-0 e-font-12 e-alt-font-poppins e-font-weight-500 line-height-14px">
                                                {data.label}
                                            </p>
                                            <span className='e-text-dark-jet e-font-10 e-alt-font-poppins e-font-weight-400 line-height-14px'>
                                                {data.description}
                                            </span>
                                        </div>
                                        <img src={props.selectedType === data.slug ? Active : Inactive}
                                            draggable="false"
                                            width={16}
                                            height={16}
                                            alt="radio" />
                                    </div>
                                </React.Fragment>
                            ))
                        }
                    </div>
                    :
                    ""
            }
        </>
    )
}

export default memo(MandateOptions);